import { render, staticRenderFns } from "./Landing2Booking.vue?vue&type=template&id=86c0191c&scoped=true"
import script from "./Landing2Booking.vue?vue&type=script&lang=js"
export * from "./Landing2Booking.vue?vue&type=script&lang=js"
import style0 from "./Landing2Booking.vue?vue&type=style&index=0&id=86c0191c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c0191c",
  null
  
)

export default component.exports